module.exports = __webpack_public_path__ + "static/media/QR-code-avator.136d52ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/dialog/QR-code-avator.png
// module id = 401
// module chunks = 1